import { getRegionalEfficiencies, postRegionalEfficiency, putRegionalEfficiency } from '../../../Api/services/backoffice';
import region from '../../../Utils/Select/optionsLists/region';

export const key = 'regionalEfficiency';

const entityName = {
  singular: 'Eficiência Regional',
  plural: 'Eficiências Regionais',
};

const queries = {
  list: { key, fn: getRegionalEfficiencies },
  detail: { key },
};

const mutations = {
  create: postRegionalEfficiency,
  update: putRegionalEfficiency,
};

const getRegionLabel = (value) => region.find((el) => el.value === value)?.label ?? value;

const fields = {
  table: [
    { key: 'regional', label: 'Região', render: (value) => getRegionLabel(value) },
    { key: 'efficiency', label: 'Eficiência' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  hideCreateButton: true,
};

export const updateConfig = {
  entityName: entityName.singular,
  mutationFn: mutations.update,
  queryConfig: queries.detail,
};
